/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

import { fancyFirebaseGetters, fancyFirebaseReferencer } from '@touchplan/fancy-referencer';

/** A temp thing to check and see if a list of tickets has any attachment data for a temp float space fix */

import firebase from 'firebase/compat/app';

export class HasAttachment {
	public getPathsForTicketsOnSamePlan(projectId: string, planId: string, ticketIds: string[]) {
		return ticketIds.map((ticketId) =>
			fancyFirebaseGetters.getTicketAttachmentsPath(projectId, planId, ticketId)
		);
	}

	public fetchAttachmentsForTickets(ticketPaths: string[], projectId: string) {
		return Promise.all(
			ticketPaths.map((path) =>
				fancyFirebaseReferencer.getLegacyRef<firebase.database.Reference>(path, projectId).once('value')
			)
		);
	}

	public hasAnyAttachments(ticketPaths: string[], projectId: string) {
		return this.fetchAttachmentsForTickets(ticketPaths, projectId).then((list) => {
			return list.some((t) => t.exists());
		});
	}
}

export const hasAttachment = new HasAttachment();
